<template>
  <div class="shortPlayDetailContainer">
    <div class="mainTitleTop">{{ id ? "编辑剧目" : "创建剧目" }}</div>

    <div class="mainContain">
      <div class="mainInnerContain">
        <div class="label"><span class="require">*</span>剧目标题</div>
        <input v-model="title" placeholder="请输入剧目标题" maxlength="30" />
        <div class="intro">
          标题为 1~30 个字，包含主题、内容、类别等关键词，更有利于推荐
        </div>

        <div class="label"><span class="require">*</span>剧目封面</div>
        <el-upload
          drag
          action="no"
          accept="image/*"
          :before-upload="onBeforeUpload"
          :http-request="uploadFn"
          class="uploadElemBox"
        >
          <img v-if="thumb" :src="thumb" class="thumb" />
          <img v-else src="../../../assets/shortPlay/add.png" class="thumb" />
        </el-upload>
        <div class="intro">
          支持jpg、png、jpeg格式的图片，单个文件不能超过5MB，推荐尺寸232*310
        </div>

        <div class="label"><span class="require">*</span>短剧分类</div>
        <div class="classifyContain">
          <el-select v-model="classifyId" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <input
            v-model="rightCode"
            placeholder="请输入短剧备案号"
            maxlength="50"
          />
        </div>

        <div class="payContain">
          <div class="payTitle">剧目付费配置</div>
          <!-- <el-switch
          v-model="needPay"
          active-color="#ea0e0e"
          inactive-color="#f5f5f5"
        >
        </el-switch> -->
        </div>
        <div class="payDetail" v-if="needPay">
          <div class="innerContain">
            <div class="mainTitle">配置详情：</div>
            <div class="iconContain" @click="configureShow()">
              <img src="../../../assets/shortPlay/edit.png" class="editIcon" />
              <div>编辑</div>
            </div>
          </div>
          <div class="innerContain">
            <div>承诺更新集数</div>
            <div v-if="payConfig.episodeLength">
              {{ payConfig.episodeLength }}集
            </div>
          </div>
          <div class="innerContain">
            <div>更新完成时间</div>
            <div v-if="payConfig.episodeLength">
              {{ payConfig.time | transTime }}
            </div>
          </div>
          <div class="innerContain">
            <div>商品价格</div>
            <div v-if="payConfig.episodeLength">
              {{ typeId | transType(types) }}-{{
                typeId == 1
                  ? payConfig.priceWhole + "顶点"
                  : typeId == 2
                  ? payConfig.price + "顶点"
                  : payConfig.priceWhole + "顶点+" + payConfig.price + "顶点"
              }}{{ allowHelp ? "（3人助力）" : "" }}
            </div>
          </div>
          <div class="innerContain">
            <div style="flex-shrink: 0; margin-right: 10px">限免配置</div>
            <div v-if="payConfig.episodeLength">
              {{ payConfig.freeList.join("、") }}
            </div>
          </div>
        </div>
      </div>
      <div class="label">剧目内作品（{{ collectionList.length }}）</div>
      <!-- <div class="addContain" @click="openVideos()">
        <img src="../../../assets/shortPlay/upload.png" class="icon" />
        <div class="addText">点击添加作品</div>
        <div class="addIntro">添加上传的视频作品到你的剧目里</div>
      </div> -->

      <draggable
        class="scriptList"
        v-if="collectionList.length"
        v-model="collectionList"
        @end="dragEnd()"
      >
        <div
          v-for="(item, index) in collectionList"
          :key="index"
          class="scriptListItem"
        >
          <div class="cover-container" v-if="item.coverList.length > 0">
            <el-image
              class="cover"
              fit="cover"
              :src="item.coverList[0]"
              :preview-src-list="item.coverList"
            />
          </div>
          <div class="info-box">
            <div class="infoContainer">
              <p class="title" @click="toDetail(item)">
                {{ item.title }}
              </p>
              <p class="create-time">{{ formatDate(item.createdDate) }}</p>
            </div>
            <div class="infoContainer action-bar">
              <div class="ext-info">
                <span>播放 {{ item.digest.playTimes }}</span>
                <span>转发 {{ item.digest.shareTimes }}</span>
                <!-- <span>收藏 {{ item.digest.collectTimes }}</span> -->
              </div>
              <div class="actionContainer">
                <p class="btns" @click="deleteCollect(index)">
                  <span>移除剧目</span>
                </p>
                <p class="btns">
                  <el-popover
                    placement="top"
                    width="260"
                    v-model="item.visible"
                    @show="sortShow(index)"
                  >
                    <p>当前顺序第{{ index + 1 }}位</p>
                    <p>
                      更改为第<el-input
                        v-model="item.indexChange"
                        placeholder=""
                        type="number"
                        style="width: 80px; height: 25px; margin: 10px 10px"
                      ></el-input
                      >位
                    </p>
                    <div style="text-align: right; margin: 20px 0 0 0">
                      <el-button
                        size="mini"
                        type="text"
                        @click="item.visible = false"
                        >取消</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="sortSubmit(item, index)"
                        >确定</el-button
                      >
                    </div>
                    <span slot="reference">更改顺序</span>
                  </el-popover>
                </p>
              </div>
            </div>
          </div>
        </div>
      </draggable>

      <div class="actionContain">
        <div class="submitBtn" @click="submit()">完成</div>
        <div class="resetBtn" @click="cancelFn()">取消</div>
      </div>
    </div>

    <el-dialog
      title="剧目付费配置"
      :visible.sync="configureVisible"
      class="configureContainer"
      width="540px"
      top="5vh"
      :close-on-click-modal="false"
    >
      <div class="label"><span class="require">*</span>承诺更新集数</div>
      <input
        type="number"
        v-model="listLength"
        placeholder="请输入"
        class="lengthInput"
        min="1"
        max="999"
      />
      <div class="intro">
        付费剧目需设定承诺更新集数，全部更新完成后才可提现
      </div>
      <div class="label"><span class="require">*</span>更新完成时间</div>
      <el-date-picker v-model="endTime" type="date" placeholder="选择日期">
      </el-date-picker>
      <div class="intro">
        请在设定的“更新完成时间”前完成所有更新，如未按照约定完成更新，将会向已购用户进行退款
      </div>
      <div class="label"><span class="require">*</span>定价方式</div>
      <div class="typeContain">
        <div class="innerLabel">售卖方式：</div>
        <el-select
          v-model="typeId"
          placeholder="请选择"
          :disabled="$route.query.id"
        >
          <el-option
            v-for="item in types"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="priceContain" v-if="typeId != 2">
        <div class="innerLabel">全集价格：</div>
        <!-- <input
          type="number"
          v-model="priceYuan"
          placeholder="请输入"
          class="lengthInput"
        />
        <div class="innerLabel">&nbsp;元&nbsp;+&nbsp;</div> -->
        <input
          type="number"
          v-model="priceDingWhole"
          placeholder="请输入"
          class="lengthInput"
          :disabled="$route.query.id"
        />
        <div class="innerLabel">&nbsp;顶点</div>
      </div>
      <div class="priceContain" v-if="typeId != 1">
        <div class="innerLabel">单集售价：</div>
        <!-- <input
          type="number"
          v-model="priceYuan"
          placeholder="请输入"
          class="lengthInput"
        />
        <div class="innerLabel">&nbsp;元&nbsp;+&nbsp;</div> -->
        <input
          type="number"
          v-model="priceDing"
          placeholder="请输入"
          class="lengthInput"
          :disabled="$route.query.id"
        />
        <div class="innerLabel">&nbsp;顶点</div>
      </div>
      <div class="episodesContain" v-if="typeId != 1">
        <div class="innerLabel">付费集数：</div>
        <div class="episodes">
          <div
            class="episode"
            :class="{ active: episodeAll }"
            @click="episodeChoose('all')"
          >
            全选
          </div>
          <div
            v-for="(item, index) in collectionList"
            :key="index"
            class="episode"
            @click="episodeChoose(index + 1)"
            :class="{ active: episodeChooseList.includes(index + 1) }"
          >
            {{ index + 1 }}
          </div>
        </div>
      </div>
      <div class="intro" v-if="typeId != 1" style="padding-left: 70px">
        勾选的集数需付费观看，其他集数可免费观看
      </div>
      <div class="helpContain">
        <el-checkbox v-model="allowHelp"></el-checkbox>
        <div class="innerLabel">&nbsp;&nbsp;允许邀请好友助力解锁</div>
        <!-- <input
          type="number"
          v-model="personSingle"
          placeholder="请输入"
          class="lengthInput"
        />
        <div class="innerLabel">&nbsp;人/单集&nbsp;</div>
        <input
          type="number"
          v-model="personAll"
          placeholder="请输入"
          class="lengthInput"
        />
        <div class="innerLabel">&nbsp;人/全集</div> -->
      </div>
      <div class="label"><span class="require">*</span>协议确认</div>
      <div class="agreeContain">
        <el-checkbox v-model="agree"></el-checkbox>
        <div class="protocol" @click="agree = !agree">
          请阅读并同意
          <span class="link" @click.stop="toProtocol()"
            >《付费内容功能使用协议》</span
          >
          确保上传内容合法合规，平台鼓励原创或获得有效合法授权的内容，避免发布营销性质较强内容。
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="configureVisible = false">取 消</el-button>
        <el-button type="primary" @click="configureFn">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="添加短剧到剧目中"
      :visible.sync="collectionAddVisible"
      width="1000px"
      top="5vh"
      class="collectionAddContainer"
      :close-on-click-modal="false"
    >
      <el-input
        v-model="collectionAddKeyword"
        placeholder="请输入关键词"
        clearable
        class="collectionAddKeyword"
        @keyup.enter.native="getVideoList(1)"
        @clear="openVideos()"
      ></el-input>
      <el-button type="primary" @click="getVideoList(1)">查 询</el-button>
      <div class="videoCollectContainer publicScroll">
        <div
          v-for="(item, index) in collectionAddList"
          :key="index"
          class="scriptListItem"
        >
          <el-checkbox
            v-model="item.checked"
            @change="(checked) => handleCheckVideo(checked, item)"
          ></el-checkbox>
          <div class="bgContainer">
            <div class="cover-container" v-if="item.coverList.length > 0">
              <el-image
                class="cover"
                fit="cover"
                :src="item.coverList[0]"
                :preview-src-list="item.coverList"
              />
            </div>
            <div class="info-box">
              <div class="infoContainer">
                <p class="title" @click="toDetail(item)">
                  {{ item.title }}
                </p>
              </div>
              <p class="create-time">
                发布于{{ formatDate(item.createdDate) }}
              </p>
              <div class="infoContainer action-bar">
                <div class="ext-info">
                  <span>播放 {{ item.digest.playTimes }}</span>
                  <span>转发 {{ item.digest.shareTimes }}</span>
                  <!-- <span>收藏 {{ item.digest.collectTimes }}</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="searchNoDataContainer" v-if="collectionAddList.length == 0">
        <img src="../../../assets/script/no.png" class="noDataImg" />
        <p class="noDataText">暂无数据</p>
      </div>
      <el-pagination
        background
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      />
      <br />
      <div slot="footer" class="dialog-footer">
        <el-button @click="collectionAddVisible = false">取 消</el-button>
        <el-button type="primary" @click="addVideosFn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { HS_upload } from "./../../../utils/huoshanUpload";
import { TOPNEWS_HOST } from "../../../constants/apiHosts";
import draggable from "vuedraggable";

export default {
  data() {
    return {
      id: "",
      title: "",
      thumb: "",
      options: [],
      classifyId: "",
      rightCode: "",
      needPay: true,
      configureVisible: false,
      listLength: "",
      endTime: "",
      types: [
        {
          value: "1",
          label: "全集付费",
        },
        {
          value: "2",
          label: "单集付费",
        },
        {
          value: "3",
          label: "全集+单集付费",
        },
      ],
      typeId: "2",
      priceYuan: "",
      priceDing: "",
      priceDingWhole: "",
      episodeChooseList: [], //选中的收费集index+1，即按钮展示的集数
      episodeAll: false,
      allowHelp: false,
      personSingle: "",
      personAll: "",
      agree: false,
      collectionList: [], //已选集 item
      collectionAddVisible: false,
      collectionAddList: [], //待选集 item
      pageSize: 20,
      currentPage: 1,
      total: 1,
      collectionAddKeyword: "",
      currentAddKeyword: "",
      collectionAddChecks: [], //弹窗选中的集 item
      payConfig: {
        episodeLength: 0,
        time: "",
        price: 0,
        priceWhole: 0,
        freeList: [],
      },
      submitting: false,
    };
  },
  filters: {
    transType(type, types) {
      let typeName = "";
      types.forEach((item) => {
        if (item.value == type) {
          typeName = item.label;
        }
      });
      return typeName;
    },
    transTime(timestamp) {
      if (timestamp) {
        const dateObj = new Date(timestamp);
        const year = dateObj.getFullYear();
        const month = dateObj.getMonth() + 1;
        const day = dateObj.getDate();
        return year + "年" + month + "月" + day + "日";
      }
    },
  },
  components: {
    draggable,
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetail();
      this.agree = true;
    } else {
      this.getTypeList();
      this.getVideoList();
    }
  },
  mounted() {},
  methods: {
    getTypeList() {
      this.$axios.get(`${TOPNEWS_HOST}/api/md/series/typeList`).then((res) => {
        if (res.data.code == 0) {
          this.options = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    getDetail() {
      this.$axios
        .get(`${TOPNEWS_HOST}/api/md/series/myDetail?id=${this.id}`)
        .then((res) => {
          if (res.data.code == 0) {
            this.title = res.data.data.title;
            this.thumb = res.data.data.coverList[0];
            this.classifyId = res.data.data.typeIdList
              ? res.data.data.typeIdList[0]
              : "";
            this.rightCode = res.data.data.copyrightNumber;
            this.payConfig.episodeLength = res.data.data.totalNum;
            this.listLength = res.data.data.totalNum;
            this.endTime = new Date(res.data.data.deadline - 86399000);
            this.payConfig.time = new Date(res.data.data.deadline);
            this.typeId =
              res.data.data.saleType == "WHOLE"
                ? "1"
                : res.data.data.saleType == "SINGLE"
                ? "2"
                : "3";
            this.payConfig.priceWhole = res.data.data.wholePoints;
            this.payConfig.price = res.data.data.singlePoints;
            this.priceDingWhole = res.data.data.wholePoints;
            this.priceDing = res.data.data.singlePoints;
            this.allowHelp = res.data.data.assistEnable;

            this.getTypeList(res.data.data.title);

            this.getVideoNow(res.data.data);
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getVideoNow(mainData) {
      this.$axios
        .get(
          `${TOPNEWS_HOST}/api/md/drama/myList?page=1&sort=true&size=500&title=&status=6&seriesIds=${this.id}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            mainData.chargeDramaList = mainData.chargeDramaList || [];
            mainData.freeDramaList = mainData.freeDramaList || [];

            res.data.data.list.forEach((item, index) => {
              item.checked = false;
              item.indexChange = "";
              item.visible = false;
              if (mainData.chargeDramaList.includes(item.id)) {
                this.episodeChooseList.push(index + 1);
              }
              if (!this.episodeChooseList.includes(index + 1)) {
                this.payConfig.freeList.push(index + 1);
              }
            });

            this.collectionList = res.data.data.list;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    configureShow() {
      this.configureVisible = true;
    },
    configureFn() {
      if (this.listLength < 1) {
        this.$message({
          message: "请输入正确的承诺更新集数",
          type: "warning",
        });
      } else if (this.listLength > 999) {
        this.$message({
          message: "承诺更新集数应小于或等于999集",
          type: "warning",
        });
      } else if (this.endTime == "") {
        this.$message({
          message: "请选择更新完成时间",
          type: "warning",
        });
      } else if (
        new Date(this.endTime).getTime() + 86399000 <=
        new Date().getTime()
      ) {
        this.$message({
          message: "请选择正确的更新完成时间",
          type: "warning",
        });
      } else if (
        (this.typeId == "1" && this.priceDingWhole < 1) ||
        (this.typeId == "2" && this.priceDing < 1) ||
        (this.typeId == "3" && (this.priceDingWhole < 1 || this.priceDing < 1))
      ) {
        this.$message({
          message: "请输入正确的顶点数",
          type: "warning",
        });
      } else if (!this.agree) {
        this.$message({
          message: "请阅读并同意协议",
          type: "warning",
        });
      } else {
        this.payConfig.episodeLength = parseInt(this.listLength);
        this.payConfig.time = new Date(this.endTime.getTime() + 86399000);
        this.payConfig.price = parseInt(this.priceDing);
        this.payConfig.priceWhole = parseInt(this.priceDingWhole);
        this.payConfig.freeList = [];

        this.collectionList.forEach((item, index) => {
          if (!this.episodeChooseList.includes(index + 1)) {
            this.payConfig.freeList.push(index + 1);
          }
        });

        this.configureVisible = false;
      }
    },
    episodeChoose(obj) {
      if (
        obj === "all" &&
        this.episodeChooseList.length == this.collectionList.length
      ) {
        this.episodeChooseList = [];
        this.episodeAll = false;
      } else if (obj === "all") {
        this.episodeChooseList = [];
        this.collectionList.forEach((item, index) => {
          this.episodeChooseList.push(index + 1);
        });
        this.episodeAll = true;
      } else if (this.episodeChooseList.indexOf(obj) > -1) {
        this.episodeChooseList.splice(this.episodeChooseList.indexOf(obj), 1);
        this.episodeAll = false;
      } else {
        this.episodeChooseList.push(obj);
        if (this.episodeChooseList.length == this.collectionList.length) {
          this.episodeAll = true;
        }
      }
    },
    submit() {
      if (this.title.length < 1) {
        this.$message({
          message: "请输入剧目标题",
          type: "warning",
        });
      } else if (this.thumb == "") {
        this.$message({
          message: "请上传剧目封面",
          type: "warning",
        });
      } else if (this.classifyId == "") {
        this.$message({
          message: "请选择短剧分类",
          type: "warning",
        });
      } else if (this.payConfig.episodeLength == 0) {
        this.$message({
          message: "请编辑剧目付费配置",
          type: "warning",
        });
      } else {
        if (this.submitting) {
          this.$message({
            message: "提交中，请勿重复提交",
            type: "warning",
          });
          return;
        } else {
          this.submitting = true;
        }

        let chargeDramaArray = [],
          freeDramaArray = [],
          dramaIdArray = [];
        this.collectionList.forEach((item, index) => {
          dramaIdArray.push(item.id);
          if (this.episodeChooseList.includes(index + 1)) {
            chargeDramaArray.push(item.id);
          } else {
            freeDramaArray.push(item.id);
          }
        });
        this.$axios
          .post(`${TOPNEWS_HOST}/api/md/series/save`, {
            id: this.id,
            title: this.title,
            cover: JSON.stringify([this.thumb]),
            typeId: JSON.stringify([this.classifyId]),
            copyrightNumber: this.rightCode,
            totalNum: this.payConfig.episodeLength,
            deadline: this.formatDate(this.payConfig.time),
            saleType:
              this.typeId == 1
                ? "WHOLE"
                : this.typeId == 2
                ? "SINGLE"
                : "ALL_AND_SINGLE",
            singlePoints: this.payConfig.price,
            wholePoints: this.payConfig.priceWhole,
            assistEnable: this.allowHelp,
            chargeDrama: JSON.stringify(chargeDramaArray),
            freeDrama: JSON.stringify(freeDramaArray),
            dramaId: JSON.stringify(dramaIdArray),
          })
          .then((res) => {
            if (res.data.code == 0) {
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.$router.push({
                path: "/shortPlay",
              });
            } else {
              this.submitting = false;

              this.$message.error(res.data.msg);
            }
          })
          .catch((error) => {
            this.submitting = false;

            this.$message.error("服务端错误");
          });
      }
    },
    cancelFn() {
      this.$router.back();
    },
    toDetail(item) {
      return;
      let routeUrl = this.$router.resolve({
        path: "/scriptDetail",
        query: {
          scriptId: item.id,
          type: "episode",
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    deleteCollect(index) {
      this.$confirm("确认把视频移除剧目吗？", "移除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.collectionList.splice(index, 1);

          this.payConfig.freeList = [];
          this.episodeChooseList = [];

          this.$message({
            message: "移除成功，请打开付费配置重新选择付费集数",
            type: "warning",
          });
        })
        .catch(() => {});
    },
    sortShow(index) {
      this.collectionList[index].indexChange = index + 1;
    },
    sortSubmit(item, index) {
      item.indexChange = parseInt(item.indexChange);
      if (item.indexChange < 1) {
        this.$message({
          message: "请输入正确的位数数字",
          type: "warning",
        });
      } else if (index + 1 > item.indexChange) {
        this.collectionList.splice(
          item.indexChange - 1,
          0,
          this.collectionList[index]
        );
        this.collectionList.splice(index + 1, 1);
        item.visible = false;

        this.$message({
          message: "更改顺序成功，请打开付费配置重新选择付费集数",
          type: "warning",
        });
      } else {
        this.collectionList.splice(
          item.indexChange,
          0,
          this.collectionList[index]
        );
        this.collectionList.splice(index, 1);
        item.visible = false;

        this.$message({
          message: "更改顺序成功，请打开付费配置重新选择付费集数",
          type: "warning",
        });
      }
    },
    dragEnd() {
      this.$message({
        message: "更改顺序成功，请打开付费配置重新选择付费集数",
        type: "warning",
      });
    },
    openVideos() {
      this.currentAddKeyword = "";
      this.collectionAddKeyword = "";
      this.currentPage = 1;
      this.collectionAddChecks = JSON.parse(
        JSON.stringify(this.collectionList)
      );
      this.getVideoList();
      this.collectionAddVisible = true;

      this.$nextTick(() => {
        document.getElementsByClassName(
          "videoCollectContainer"
        )[0].scrollTop = 0;
      });
    },
    getVideoList(isSearch) {
      if (isSearch == 1) {
        this.currentAddKeyword = this.collectionAddKeyword;
        this.currentPage = 1;
      }
      this.$axios
        .get(
          `${TOPNEWS_HOST}/api/md/drama/myList?page=${
            this.currentPage
          }&sort=true&size=${this.pageSize}&title=${
            this.currentAddKeyword
          }&status=6&seriesIds=0${this.id ? "," + this.id : ""}`
        )
        .then((res) => {
          if (res.data.code == 0) {
            res.data.data.list.forEach((item) => {
              if (this.checkCollection(item.id) > -1) {
                item.checked = true;
              } else {
                item.checked = false;
              }
              item.indexChange = "";
              item.visible = false;
            });
            this.collectionAddList = res.data.data.list;
            this.total = res.data.data.total;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getVideoList();

      document.getElementsByClassName("videoCollectContainer")[0].scrollTop = 0;
    },
    handleCheckVideo(val, item) {
      if (val) {
        if (this.checkCollection(item.id) < 0) {
          this.collectionAddChecks.push(item);
        }
      } else {
        if (this.checkCollection(item.id) > -1) {
          this.collectionAddChecks.splice(this.checkCollection(item.id), 1);
        }
      }
    },
    checkCollection(itemId) {
      let itemIndex = -1;
      this.collectionAddChecks.forEach((item, index) => {
        if (item.id == itemId) {
          itemIndex = index;
        }
      });
      return itemIndex;
    },
    addVideosFn() {
      this.collectionList = JSON.parse(
        JSON.stringify(this.collectionAddChecks)
      );
      this.collectionAddVisible = false;
    },
    toProtocol() {
      window.open(
        "https://activity.topnews.cn/creator/static/html/ddPay.html"
      );
    },
    onBeforeUpload(file) {
      const isIMAGE = file.type.indexOf("image/") >= 0;

      if (!isIMAGE) {
        this.$message.error("上传文件只能是图片格式！");
        return false;
      } else {
        return true;
      }
    },
    uploadFn(val) {
      HS_upload(
        val.file,
        (data) => {
          this.thumb = data.url;
        },
        (error) => {},
        (processPercent) => {}
      );
    },
    formatDate(date) {
      date = new Date(date);
      var year = date.getFullYear();
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      var hours = ("0" + date.getHours()).slice(-2);
      var minutes = ("0" + date.getMinutes()).slice(-2);
      var seconds = ("0" + date.getSeconds()).slice(-2);
      return (
        year +
        "-" +
        month +
        "-" +
        day +
        " " +
        hours +
        ":" +
        minutes +
        ":" +
        seconds
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.shortPlayDetailContainer {
  padding-bottom: 25px;
  background-color: #ffffff;
  border-radius: 8px;

  .mainTitleTop {
    width: calc(100% - 32px);
    color: #333333;
    font-family: "PingFang SC";
    font-size: 18px;
    font-weight: 400;
    line-height: 65px;
    padding-left: 32px;
    border-bottom: 2px solid #f6f7f9;
  }

  .mainContain {
    padding: 0 32px;

    .mainInnerContain {
      width: 720px;
    }

    .label {
      color: #4e5969;
      font-family: "PingFang SC";
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      margin-top: 20px;

      .require {
        color: red;
      }
    }

    input {
      width: 100%;
      border-radius: 2px;
      background: #f6f7f9;
      height: 40px;
      margin-top: 8px;
      padding: 0 12px;

      &::placeholder {
        color: #cccccc;
      }
    }

    .intro {
      color: #999999;
      font-family: "PingFang SC";
      font-size: 12px;
      font-weight: 400;
      line-height: 20px;
      margin-top: 4px;
    }

    /deep/.el-upload {
      width: 80px;
      height: 107px;
      margin-top: 8px;

      .el-upload-dragger {
        width: 100%;
        height: 100%;
      }

      .thumb {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    /deep/.el-upload-list {
      display: none;
    }

    .classifyContain {
      height: 40px;
      display: flex;
      align-items: center;
      margin-top: 8px;

      .el-select {
        margin-right: 10px;

        /deep/.el-input {
          margin: 0;

          input {
            background: #f6f7f9;
            border: 0;
          }
        }
      }

      input {
        margin-top: 0;
      }
    }
  }

  .payContain {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    color: #4e5969;
    font-family: "PingFang SC";
    font-size: 14px;
    font-weight: 400;
  }

  .payDetail {
    border-radius: 2px;
    background: #f6f7f9;
    margin-top: 8px;
    padding: 16px 12px 8px 12px;

    .innerContain {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 8px;
      color: #999999;
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;

      .mainTitle {
        color: #333333;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 16px;
      }

      .iconContain {
        display: flex;
        color: #333333;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;
        margin-bottom: 16px;
        cursor: pointer;

        .editIcon {
          height: 16px;
          margin-right: 4px;
        }
      }
    }
  }

  .addContain {
    width: 100%;
    height: 169px;
    border-radius: 2px;
    background: #f6f7f9;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
    cursor: pointer;

    .icon {
      height: 40px;
    }

    .addText {
      color: #333333;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 14px;
      font-weight: 500;
      margin-top: 8px;
    }

    .addIntro {
      color: #999999;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 12px;
      font-weight: 400;
      margin-top: 4px;
    }
  }

  .scriptList {
    border-top: 1px solid #edf1f8;
    padding-bottom: 20px;

    .scriptListItem {
      border-bottom: 1px solid #edf1f8;
      padding: 16px 0;
      display: flex;
      min-height: 90px;
      box-sizing: content-box;

      .cover-container {
        width: 160px;
        height: 90px;
        border-radius: 6px;
        overflow: hidden;
        background: #ccc;
        margin-right: 20px;

        .cover {
          height: 100%;
          width: 100%;
        }
      }

      .info-box {
        flex: 1;
        position: relative;

        .infoContainer {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .title {
            flex: 1;
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            color: #333333;
            font-weight: bold;
            font-size: 16px;
            cursor: pointer;
            line-height: 20px;
          }

          .create-time {
            color: #999999;
            font-size: 14px;
          }

          .actionContainer {
            display: flex;
            line-height: 30px;

            .btns {
              margin-right: 20px;
              color: #5574e7;
              font-size: 14px;
              cursor: pointer;
            }
          }
        }

        .infoContainer.action-bar {
          position: absolute;
          bottom: -6px;
          right: 0;
          width: 100%;
          display: block;

          .ext-info {
            color: #999999;
            span {
              margin-right: 20px;
            }
          }
          .actionContainer {
            flex: 1;
          }
        }
      }
    }
  }

  .actionContain {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    .submitBtn {
      width: 74px;
      line-height: 36px;
      border-radius: 2px;
      background: #d7000f;
      color: #ffffff;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
    }

    .resetBtn {
      width: 74px;
      line-height: 36px;
      border-radius: 2px;
      border: 1px solid #ccc;
      color: #333333;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 14px;
      font-weight: 400;
      margin-left: 20px;
      cursor: pointer;
    }
  }

  /deep/.configureContainer {
    .el-dialog__body {
      padding-top: 0;

      .label {
        color: #4e5969;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        margin-top: 20px;

        .require {
          color: red;
        }
      }

      .lengthInput {
        width: 100%;
        border-radius: 2px;
        background: #f6f7f9;
        height: 36px;
        margin-top: 8px;
        padding: 0 12px;

        &::placeholder {
          color: #cccccc;
        }
      }

      .lengthInput[disabled="disabled"] {
        color: #c0c4cc;
      }

      .intro {
        color: #999999;
        font-family: "PingFang SC";
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        margin-top: 4px;
      }

      .el-date-editor {
        width: 100%;
        margin-top: 8px;
        margin-bottom: 0;

        input {
          background: #f6f7f9;
          border: 0;
          cursor: pointer;
        }
      }

      .typeContain {
        display: flex;
        align-items: center;
        margin-top: 8px;
        color: #333333;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;

        .el-select {
          flex: 1;

          .el-input {
            margin-bottom: 0;

            input {
              background: #f6f7f9;
              border: 0;
            }
          }
        }
      }

      .priceContain {
        display: flex;
        align-items: center;
        margin-top: 8px;
        color: #333333;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;

        .innerLabel {
          flex-shrink: 0;
        }

        input {
          width: auto;
          margin-top: 0;
        }
      }

      .episodesContain {
        display: flex;
        margin-top: 8px;
        color: #333333;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;

        .innerLabel {
          flex-shrink: 0;
        }

        .episodes {
          display: flex;
          flex-wrap: wrap;

          .episode {
            width: 42px;
            line-height: 36px;
            border-radius: 2px;
            background: #f6f7f9;
            text-align: center;
            cursor: pointer;
            margin: 0 4px 4px 0;

            &:nth-child(9) {
              margin-right: 0;
            }
          }

          .active {
            color: #ffffff;
            background-color: #ea0e0e;
          }
        }
      }

      .helpContain {
        display: flex;
        align-items: center;
        margin-top: 8px;
        color: #333333;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;

        .innerLabel {
          flex-shrink: 0;
        }

        input {
          width: 100px;
          margin-top: 0;
        }
      }

      .agreeContain {
        display: flex;
        margin-top: 8px;
        color: #999999;
        font-family: "PingFang SC";
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        cursor: pointer;

        .protocol {
          margin-left: 4px;

          .link {
            color: #165dff;
          }
        }
      }
    }
  }

  /deep/.collectionAddContainer {
    .el-dialog {
      height: 86vh;

      .el-dialog__body {
        padding-top: 10px;
      }

      .collectionAddKeyword {
        width: 350px;
        margin-bottom: 15px;
      }

      .searchNoDataContainer {
        width: 100%;
        height: calc(86vh - 245px);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .noDataText {
          margin-top: 21px;
          font-size: 20px;
          color: rgb(204, 204, 204);
        }
      }

      .videoCollectContainer {
        width: 100%;
        max-height: calc(86vh - 245px);
        overflow-y: scroll;
        display: flex;
        flex-wrap: wrap;

        .scriptListItem {
          width: calc(50% - 15px);
          padding: 8px 0;
          display: flex;
          height: 110px;
          box-sizing: content-box;
          margin-right: 15px;

          .el-checkbox {
            margin: 0 10px 0 0;
            display: flex;
            align-items: center;
          }

          .bgContainer {
            width: calc(100% - 29px);
            background-color: #f6f7f9;
            display: flex;
            padding: 10px;
            border-radius: 5px;
          }

          .cover-container {
            width: 160px;
            height: 90px;
            border-radius: 6px;
            overflow: hidden;
            background: #ccc;
            margin-right: 10px;
            flex-shrink: 0;

            .cover {
              height: 100%;
              width: 100%;
            }
          }

          .info-box {
            flex: 1;
            position: relative;
            width: calc(100% - 210px);

            .title {
              width: 100%;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              color: #333333;
              font-weight: bold;
              font-size: 16px;
              cursor: pointer;
              line-height: 20px;
              height: 40px;
              margin-bottom: 13px;
            }
          }

          .create-time {
            color: #999999;
            font-size: 14px;
          }

          .infoContainer.action-bar {
            position: absolute;
            bottom: 0;
            right: 0;
            width: 100%;

            .ext-info {
              color: #999999;
              span {
                margin-right: 10px;
              }
            }
            .actionContainer {
              flex: 1;
              justify-content: flex-end;
            }
          }
        }
      }

      .el-dialog__footer {
        margin-top: 10px;
      }
    }
  }
}
</style>
